import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { OppsErrorStateComponent } from './shared/components/opps-error-state/opps-error-state.component';
import { ValidateLoginComponent } from './shared/components/validate-login/validate-login.component';
import { DependentInformationFormComponent } from './modules/cam/components/dependent-information-form/dependent-information-form.component';
import { StopOnboardingComponent } from './shared/components/stop-onboarding/stop-onboarding.component';
import { LayoutComponent } from './layout/layout.component';
import { ValidateLogoutComponent } from './shared/components/validate-logout/validate-logout.component';
import { LinkExpiredComponent } from './shared/components/link-expired/link-expired.component';
import { LoginLandingComponent } from './shared/components/login-landing/login-landing.component';
import { roleGuard } from './shared/guards/role.guard';
const routes: Routes = [
  { path: 'validatelogin', component: ValidateLoginComponent },
  { path: 'login-landing', component: LoginLandingComponent },
  { path: 'imperva', loadChildren: () => import('./modules/landingPages/landing-pages.module').then(m => m.LandingPagesModule) },
  { path: '', loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule) },
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule), },
  { path: 'forgetPassword/:Mode', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'SearchEngine', loadChildren: () => import('./modules/search-engine/search-engine.module').then(m => m.SearchEngineModule) },
  { path: 'Dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [authGuard] },
  { path: 'flight', loadChildren: () => import('./modules/flight/flight.module').then(m => m.FlightModule), canActivate: [authGuard] },
  { path: 'passenger', loadChildren: () => import('./modules/passenger/passenger.module').then(m => m.PassengerModule), canActivate: [authGuard] },
  { path: 'extra-services', loadChildren: () => import('./modules/add-ons/add-ons.module').then(m => m.AddOnsModule), canActivate: [authGuard] },
  { path: 'payment', loadChildren: () => import('./modules/payment/payment.module').then(m => m.PaymentModule) },
  { path: 'flight-multicity', loadChildren: () => import('./modules/flight-multicity/flight-multicity.module').then(m => m.FlightMulticityModule), canActivate: [authGuard] },
  { path: 'bookings', loadChildren: () => import('./modules/bookings/bookings.module').then(m => m.BookingsModule), canActivate: [authGuard] },
  { path: 'cam', loadChildren: () => import('./modules/cam/cam.module').then(m => m.CAMModule), canActivate: [authGuard] },
  { path: 'validatelogout', component: ValidateLogoutComponent },
  {
    path: '', component: LayoutComponent,
    children: [
      { path: 'loyalty', loadChildren: () => import('./modules/loyalty/components/loyality.module').then(m => m.LoyaltyModule), canActivate: [authGuard, roleGuard] }
    ]
  },
  { path: 'reissue', loadChildren: () => import('./modules/flight-reissue/flight-reissue.module').then(m => m.FlightReissueModule), canActivate: [authGuard] },
  { path: 'Flight-Cancellation', loadChildren: () => import('./modules/flight-cancellation/flight-cancellation.module').then(m => m.FlightCancellationModule), canActivate: [authGuard] },
  { path: 'Help-Center', loadChildren: () => import('./modules/help-center/help-center.module').then(m => m.HelpCenterModule), canActivate: [authGuard] },
  { path: 'booking-module', loadChildren: () => import('./modules/bookings/bookings.module').then(m => m.BookingsModule), canActivate: [authGuard] },
  { path: 'error', component: OppsErrorStateComponent },
  {
    path: "", component: LayoutComponent,
    children: [
      { path: 'dependent-information-form', component: DependentInformationFormComponent, canActivate: [authGuard] },
      // {
      //   path: 'new-traveler',
      //   component: NewTravelerFormComponent
      // },
      { path: 'stop-onboarding', component: StopOnboardingComponent },
      { path: 'public-faqs', loadComponent: () => import('./modules/help-center/components/help-faqs/help-faqs.component').then(m => m.HelpFaqsComponent) },
    ]
  },
  {
    path: '', component: LayoutComponent,
    children: [
      { path: 'loyalty-dashboard', loadChildren: () => import('./modules/loyalty-dashboard/loyalty-dashboard.module').then(m => m.LoyaltyDashboardModule), canActivate: [authGuard, roleGuard] }
    ]
  },
  { path: 'reports', component: LayoutComponent, loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule), canActivate: [authGuard, roleGuard] },
  { path: 'help', component: LayoutComponent, loadChildren: () => import('./modules/help-center/help-center.module').then(m => m.HelpCenterModule), canActivate: [authGuard] },
  { path: 'linkExpired', component: LinkExpiredComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
